module.exports = __webpack_public_path__ + "img/hr-red-desert-decal-07.0914e7ea.png";